import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from '@environments/environment';
import { ContractorLeaveResponse } from '@interfaces/contractor-flow.model';
import { TimesheetResponse } from '@interfaces/vendor-management-model';

@Injectable({
  providedIn: 'root',
})
export class ContractorFlowService {
  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getContractorLeaves(employeeId: string): Observable<ContractorLeaveResponse> {
    const url = `${this.baseUrl}/vendor/leave-details/${employeeId}`;
    return this.http.get<ContractorLeaveResponse>(url);
  }

  getContractorTimesheetApi(employeeId: string): Observable<TimesheetResponse> {
    const url = `${this.baseUrl}/vendor/employee-timesheet/${employeeId}`;
    return this.http.get<TimesheetResponse>(url).pipe(
      catchError((error) => {
        return throwError(() => error);
      })
    );
  }
  saveApplyLeave(leaveData: any) {
     const url = `${this.baseUrl}/vendor/employee-leave-details`;
        return this.http.post<any>(url, leaveData).pipe(
          catchError((error) => {
            return throwError(() => error);
          }),
        );  
  }
}
